import { jsx as _jsx } from "react/jsx-runtime";
import Box from '../box';
import { useStyleConfig, vui } from '../core';
import { cs } from '../utils';
import { usePaginationContext } from './context';
/** Displays '...' ellipsis for hidden pages. */
export const PaginationEllipsis = vui((props, ref) => {
    const { children, className, ...rest } = props;
    const styles = useStyleConfig('Pagination', usePaginationContext());
    return (_jsx(Box, { alignItems: "center", className: cs('vui-paginationEllipsis', className), px: "10px", ref: ref, ...styles.ellipsis, ...rest, children: children ?? '…' }));
});
PaginationEllipsis.displayName = 'PaginationEllipsis';
export default PaginationEllipsis;
